__webpack_require__.p = "/Gradient-Generator/";